/** Uses the storefront's booth-first participant title. */
export function chatTitle(chat) {
  return chat?.boothTitle || chat?.userName || chat?.fullName || chat?.email || "گفتگو";
}

export function chatPreview(chat) {
  const value = chat?.lastMessageText || chat?.lastMessage;
  return typeof value === "string" && value.trim()
    ? value : chat?.id ? "مشاهده گفتگو" : "هنوز گفتگویی آغاز نشده است";
}

export function chatTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("fa-IR", { hour: "2-digit", minute: "2-digit" });
}

export function chatListTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toDateString() === new Date().toDateString() ? chatTime(value)
    : date.toLocaleDateString("fa-IR", { day: "numeric", month: "short" });
}

/** Converts newest-first history to chronological groups without mutating it. */
export function groupChatMessages(messages) {
  const groups = new Map();
  for (const message of Array.isArray(messages) ? [...messages].reverse() : []) {
    const date = new Date(message.createdAt);
    const valid = !Number.isNaN(date.getTime());
    const key = valid ? date.toDateString() : "unknown";
    if (!groups.has(key)) groups.set(key, {
      key,
      label: valid ? date.toLocaleDateString("fa-IR", { day: "numeric", month: "long" }) : "بدون تاریخ",
      messages: [],
    });
    groups.get(key).messages.push(message);
  }
  return [...groups.values()];
}

export function isOwnChatMessage(message, currentUserId) {
  return currentUserId ? Number(message.userId) === Number(currentUserId) : Boolean(message.boothMessage);
}
